import React, { Component } from 'react';
import { Label, Icon, Button} from 'semantic-ui-react';
import { toIDR } from '../../../../../_utils/tocurrency';
import { toDMYDate } from '../../../../../_utils/convert_datetime';
import printJS from 'print-js';

export default class ListBP extends Component {

  constructor(props){
    super(props);
    this.state = {
        datas:props.data_detail,
        total:[],
        status:[],
        jumlah:0,
        semua:false,
        semua_data:[],
        data: [],
    }
  }

  exportData(){
    printJS({
        printable: 'print_data',
        type: 'html',
        modalMessage:"Sedang memuat data...",
        showModal:true,
        maxWidth:'1300',
        font_size:'8pt',
        documentTitle:'Rincian BP',
        targetStyle: [
            'margin',
            'color',
            'border-collapse',
            'border-spacing',
            'border-style',
            'border-style',
            'margin-bottom',
            'padding',
            'Label',
            'background'
        ]
    })
 }

  render() {
    const styletb = {
        borderCollapse:'collapse',
        borderSpacing:0,
        borderStyle:'solid',
        width:'100%',
        fontSize:'12px',
        padding:'10px'
    }
    const { datas } = this.state;
    var total=[]; var status=[]; var jumlah=0; var semua_data=[];
    var jumBelumSTS=0; var jumSudahSTS=0; var jumVer=0;
    for(var i=0;i<1;i++){
        var tam2=0; var stat="";
        for(var j=0; j<datas.rincian.length;j++){
            tam2=tam2+datas.rincian[j].nilai;
        }
        if(datas.is_active===true && datas.is_verified===false){
            stat="BP Non STS";
            jumBelumSTS=jumBelumSTS+1;
        } else if(datas.is_active===false && datas.is_verified===false){
            stat="BP STS";
            jumSudahSTS=jumSudahSTS+1;
        } else if(datas.is_active===false && datas.is_verified===true){
            stat="BP Terealisasi";
            jumVer=jumVer+1;
        }
        total[i]=tam2;
        jumlah=jumlah+tam2;
        status[i]=stat;
    }
    semua_data[0]=jumBelumSTS;
    semua_data[1]=jumSudahSTS;
    semua_data[2]=jumVer;

    return (
        <div>
            <Button color='blue' size="small" onClick={()=>this.exportData()}> 
                {/* <ReactPrint
                    trigger={()=> */}
                        <p><Icon name='print' className='left floated' />Preview</p>
                    {/* } content={()=>this.componentRef}
                /> */}
            </Button>
            <br/><br/>
            <div ref={el => (this.componentRef = el)}>
            <table border="1" align="center" style={styletb} id="print_data" width="100%">
                <tbody>            
                    <tr align="left" style={{background:'#e5e5e5',padding:'4px'}}>
                        <th rowSpan="2" width="4%" style={{padding:'4px',textAlign:"center"}}>No.</th>
                        <th rowSpan="2" width="6%"style={{padding:'4px',textAlign:"center"}}>Status</th>
                        <th colSpan="2" width="20%" style={{padding:'4px',textAlign:"center"}}>Nomor</th>
                        <th colSpan="2" style={{padding:'4px',textAlign:"center"}}>Tanggal</th>
                        <th rowSpan="2" style={{padding:'4px',textAlign:"center"}}>Keterangan</th>
                        <th rowSpan="2" style={{padding:'4px',textAlign:"center"}}>Rincian</th>
                        <th rowSpan="2" style={{padding:'4px',textAlign:"center"}}>Total</th>
                    </tr>
                    <tr align="left" style={{background:'#e5e5e5',padding:'4px'}}>
                        <th style={{padding:'4px',textAlign:"center"}}>BP</th>
                        <th style={{padding:'4px',textAlign:"center"}}>STS</th>
                        <th style={{padding:'4px',textAlign:"center"}}>Pembuatan</th>
                        <th style={{padding:'4px',textAlign:"center"}}>Realisasi</th>
                    </tr>
                    {datas.length === 0 && 
                        <tr>
                            <th colSpan="9">Data tidak ditemukan</th>                           
                        </tr>
                    }
                    {<tr> 
                        <td style={{padding:'4px',textAlign:"center"}}>{1}</td>   
                        <td style={{padding:'4px',textAlign:"center"}}>
                        {
                            (status[0]==="BP Non STS")?
                            <Label color='red' horizontal>BP Non STS</Label> :
                            (status[0]==="BP STS")?
                            <Label color='yellow' horizontal>BP STS</Label> :
                            (status[0]==="BP Terealisasi")?
                            <Label color='blue' horizontal>BP Terealisasi</Label> : null
                        }
                        </td>                                                
                        <td style={{padding:'4px',textAlign:"center"}}>{datas.no_bukti}</td>
                        <td style={{padding:'4px',textAlign:"center"}}>{ (datas.no_sts===null)? '-' :datas.no_sts }</td>
                        <td style={{padding:'4px',textAlign:"center"}}>{toDMYDate(datas.created_at)}</td>
                        <td style={{padding:'4px',textAlign:"center"}}>{toDMYDate(datas.tgl_realisasi)}</td>
                        <td style={{padding:'4px'}}>{datas.uraian}</td>
                        <td style={{padding:'4px'}}>
                        {   
                            datas.rincian.map((isi, j) =>(
                                <p key={j}>{isi.kd_rek_1+"."+isi.kd_rek_2+"."+isi.kd_rek_3+"."+isi.kd_rek_4+"."+isi.kd_rek_5+"."+isi.kd_rek_6+" = "+isi.uraian_rinc+" : "+toIDR(isi.nilai)}<br/></p>
                            ))
                        }
                        </td>
                        <td style={{padding:'4px',textAlign:"right"}}>{toIDR(total[0])}</td>
                    </tr>
                    }
                    <tr style={{background:'#e5e5e5'}}>
                        <th style={{padding:'4px'}} colSpan="8" align="right">Jumlah</th>
                        <th style={{padding:'4px'}} align="right">
                            {toIDR(jumlah)}
                        </th>
                    </tr>
                </tbody>            
            </table>
            </div>
        </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/Content/views/opd/_bp/ListBP.js